// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1mh62","options":"AnswerScale_options__1RqsU","selected":"AnswerScale_selected__Hsbqm"};